import React, { useState, useContext, useEffect } from 'react';
import Modal from 'react-modal';
// import { loginMergeIdentity } from '../../graphql/cart';
import log from 'loglevel';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useForm } from 'react-hook-form';
import { Auth } from '@aws-amplify/auth';

const modalStyles = {
  content: {
    position: 'relative',
    marginTop: '3rem',
    inset: 0,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
};

type LoginFormData = {
  username: string;
  password: string;
};

const LoginModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const queryClient = useQueryClient();
  const [serverError, setServerError] = useState(undefined);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<LoginFormData>();
  const submitLoginMutation = useMutation({
    mutationFn: async ({ username, password }: LoginFormData) =>
      await Auth.signIn(username, password),
    onSuccess: (data) => {
      log.info({ data }, 'LoginModal:submitLoginMutation onSuccess');
      queryClient.invalidateQueries({ queryKey: ['currentUser'] });
      queryClient.invalidateQueries({ queryKey: ['GetCart'] });
      setIsOpen(false);
    },
    onError: (err) => {
      log.error({ err }, 'LoginModal:submitLoginMutation onError');
      setServerError(err);
    },
  });

  const closeModal = () => setIsOpen(false);

  /*
  const signUpConfig = {
    hideAllDefaults: true,
    signUpFields: [
      {
        label: 'Email',
        key: 'username',
        required: true,
        displayOrder: 1,
        type: 'email',
        custom: false,
      },
      {
        label: 'Password',
        key: 'password',
        required: true,
        displayOrder: 2,
        type: 'password',
        custom: false,
      },
    ],
  };
  */

  const serverErrorRendered =
    serverError !== undefined ? (
      <div className="cell small-12 callout alert">
        <h3>Login Error</h3>
        <p>{serverError.name}</p>
        <p>{serverError.message}</p>
      </div>
    ) : null;

  const rendered = (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel="Login"
      ariaHideApp={false}
      style={modalStyles}
    >
      <div className="cell small-12 medium-8 medium-offset-2">
        <button
          className="button transparent modal--close"
          onClick={closeModal}
        >
          <i className="fi-x" /> close
        </button>
        <form
          className="grid-x grid-margin-x"
          onSubmit={handleSubmit(({ username, password }) =>
            submitLoginMutation.mutate({ username, password }),
          )}
        >
          <div className="cell small-12">
            <label>
              Username
              <input {...register('username', { required: true })} />
            </label>
            {errors.username && <span>This field is required</span>}
          </div>

          <div className="cell small-12 medium-6">
            <label>
              Password
              <input
                type="password"
                {...register('password', { required: true })}
              />
            </label>
            {errors.password && <span>This field is required</span>}
          </div>

          <input type="submit" value="Login" />
          {serverErrorRendered}
        </form>
      </div>
    </Modal>
  );

  return [rendered, setIsOpen];
};

export default LoginModal;
